<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div #container
     [ngStyle]="style" fxLayout="column"
     [ngClass]="{'dash-gis-panel-minimized': minimized}"
     class="dash-gis-panel-container"
     cdkDrag [cdkDragDisabled]="isIOS"
     dashGisNg2Resizable [enableResize]="!isIOS && enableResize()"
     [enableGhostResize]="true"
     [ghostElementPositioning]="'absolute'"
     [resizeCursorPrecision]="resizeHandleWidth"
     [resizeEdges]="{bottom: true, right: true, top: true, left: true}"
     (resizeEnd)="onResizeEnd($event)">
    <mat-card appearance="raised" fxHide.print fxShow
              fxLayout="column" class="dash-gis-panel-base" fxFlex="1 1 auto">
        <div fxFlex="none">
            <div cdkDragHandle [ngStyle]="dragHandleStyle"></div>
            <mat-card-header class="dash-gis-panel-toolbar" fxLayout="row"
                             fxFlex="noshrink" fxLayoutAlign="space-between center">
                <mat-card-title class="panel-title"
                                [matTooltip]="panelTitle()">{{ panelTitle() }}
                </mat-card-title>
                <span class="panel-toolbar-actions">
                    @if (historyEnabled) {
                        <button mat-icon-button
                                matTooltip="Return to Search Criteria"
                                (click)="panelBack.emit($event)">
                            <mat-icon svgIcon="back"></mat-icon>
                        </button>
                    }
                    @if (!minimized) {
                        <button mat-icon-button (click)="onMinimize()">
                            <mat-icon svgIcon="minimize"></mat-icon>
                        </button>
                    }
                    @if (minimized) {
                        <button mat-icon-button (click)="onRestore()">
                            <mat-icon svgIcon="restore"></mat-icon>
                        </button>
                    }
                    @if (closeEnabled) {
                        <button mat-icon-button
                                matTooltip="Close Search Results"
                                (click)="closePanel.emit()">
                            <mat-icon svgIcon="close"></mat-icon>
                        </button>
                    }
                </span>
            </mat-card-header>
        </div>
        <div [ngClass]="{'dash-gis-panel-content-minimized': minimized}"
             class="dash-gis-panel-content"
             fxLayout="column" fxFlex="1 1 auto">
            <div [ngClass]="{
                    'dash-gis-panel-scrollable': enableScroll,
                    'dash-gis-panel-non-scrollable': !enableScroll
                 }"
                 fxLayout="column" fxFlex="1 1 auto">
                <ng-content></ng-content>
            </div>
        </div>
    </mat-card>
</div>
